import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-disclaimer',
  templateUrl: 'disclaimer.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class DisclaimerPage {

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }
  
  goBack(){
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/disclaimer/disclaimer.ts